import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 209.92 168.04' {...props}>
    <defs />
    <g id='Layer_2' data-name='Layer 2'>
      <g id='Layer_1-2' data-name='Layer 1'>
        <path
          className='cls-1'
          d='M195.66 58.92V41.37h-86.34v56.72h86.34zm-81.34-12.55h76.34v7.55h-76.34zm0 46.72V58.92h76.34v34.17zM100.59 58.92V41.37H14.25v56.72h86.34zM19.25 46.37h76.34v7.55H19.25zm0 46.72V58.92h76.34v34.17z'
        />
        <path
          className='cls-1'
          d='M0 0v153.53h8.3V168h195.1v-14.47h6.52V0zm195.4 160H16.3v-6.51h179.1zm6.52-14.51H8V18.92h193.92zM8 10.92V8h193.92v2.92z'
        />
      </g>
    </g>
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/CasettaIcon.js